import type { GridDensity } from '@mui/x-data-grid-pro';
import { useBuildSliceSelector } from '@pn/services/redux/useBuildSliceSelector';
import { isNil } from 'lodash-es';
import { store } from 'src/application/storage/store';
import { intelUiSlice, type PreferredAreaUnit } from './intelUiSlice';

export const useIntelUIStorage = () => {
  const { name, getInitialState } = intelUiSlice;

  const useSliceSelector = useBuildSliceSelector(name, getInitialState());

  return {
    isMapHidden: useSliceSelector((state) => state.isMapHidden),
    bottomTableHeight: useSliceSelector((state) => state.bottomTableHeight),
    isLegendHidden: useSliceSelector((state) => state.isLegendHidden),
    enableIndividualMapSelections: useSliceSelector(
      (state) => state.enableIndividualMapSelections
    ),
    preferredAreaUnits: useSliceSelector((state) => state.preferredAreaUnits),
    tableDensity: useSliceSelector((state) => state.tableDensity),
    isAreaDialogOpen: useSliceSelector((state) => state.isAreaDialogOpen),
    isExportMode: useSliceSelector((state) => state.isExportMode),
  };
};

export const intelUIActions = () => {
  const { dispatch, getState } = store;
  const { actions, name } = intelUiSlice;

  if (isNil(getState()[name])) {
    throw new Error(`[${name}] reducer has not been injected yet`);
  }

  return {
    show: () => dispatch(actions.show()),
    hide: () => dispatch(actions.hide()),
    toggleMap: () => dispatch(actions.toggleMap()),
    toggleLegend: () => dispatch(actions.toggleLegend()),
    setPreferredAreaUnits: (unit: PreferredAreaUnit) =>
      dispatch(actions.setPreferredAreaUnits(unit)),
    changeTableDensity: (density: GridDensity) =>
      dispatch(actions.changeTableDensity(density)),
    toggleIndividualMapSelections: () =>
      dispatch(actions.toggleIndividualMapSelections()),
    setBottomTableHeight: (height: number) =>
      dispatch(actions.setBottomTableHeight(height)),
    openAreaDialog: () => dispatch(actions.openAreaDialog()),
    closeAreaDialog: () => dispatch(actions.closeAreaDialog()),
    enterExportMode: () => dispatch(actions.enterExportMode()),
    exitExportMode: () => dispatch(actions.exitExportMode()),
  };
};
